export function ProcessStepDoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M13.7012 8.23016C13.9664 7.91195 13.9234 7.43903 13.6052 7.17385C13.287 6.90868 12.8141 6.95167 12.5489 7.26988L9.24453 11.2351L7.18599 9.76472C6.84893 9.52397 6.38051 9.60203 6.13976 9.93909C5.899 10.2762 5.97707 10.7446 6.31413 10.9853L9.50558 13.2649L13.7012 8.23016Z"
        fill="currentColor"
      />
    </svg>
  );
}
